$ = require 'jquery'
_ = require 'underscore'
Auth = require 'db/auth'
BoardAddToTeam = require 'views/board-menu/board-add-to-team-view'
BoardPluginItemView = require 'views/board-menu/board-plugin-item-view'
BoardPowerUpItemView = require 'views/board-menu/board-power-up-item-view'
CalendarSettingsView = require 'views/power-ups/calendar-settings-view'
CardAgingSettingsView = require 'views/power-ups/card-aging-settings-view'
Controller = require 'controller'
localizeCount = require 'lib/localize-count'
LatestPowerUpsMessage = require 'data/latest-power-ups-message'
LegacyPowerUps = require 'data/legacy-power-ups'
ModelLoader = require 'db/model-loader'
PluginIO = require 'views/internal/plugins/plugin-io'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
powerUpsUpgradeTemplate = require 'views/templates/power_ups_upgrade'
Promise = require 'bluebird'
Util = require 'lib/util'
View = require 'view'
VotingSettingsView = require 'views/power-ups/voting-settings-view'
l = require 'lib/localize'
t = require('views/internal/teacup-with-helpers')('board_power_ups')
xtend = require 'xtend'
simpleTest = require 'lib/experiments/simple-test'
track = require 'debug/track'
ClientConfig = require 'debug/client-config'
getExperiment = require 'lib/experiments/simple-test'

powerUpViewData = [
  name: 'voting'
  iconSrc: require('images/powerups/voting-icon.svg')
  aboutTemplate: 'power_ups_about_voting'
  settingsView: (model) -> new VotingSettingsView({ model })
  screenshots: [require('images/powerups/voting/screenshots/2015-3-23-screenshot1.png')]
  idPlugin: LegacyPowerUps.voting
,
  name: 'cardAging'
  iconSrc: require('images/powerups/card-aging-icon.svg')
  aboutTemplate: 'power_ups_about_card_aging'
  settingsView: (model) -> new CardAgingSettingsView({ model })
  screenshots: [require('images/powerups/card-aging/screenshots/2015-3-23-screenshot1.png')]
  idPlugin: LegacyPowerUps.cardAging
,
  name: 'calendar'
  iconSrc: require('images/powerups/calendar-icon.svg')
  aboutTemplate: 'power_ups_about_calendar'
  settingsView: (model) -> new CalendarSettingsView({ model })
  screenshots: [require('images/powerups/calendar/screenshots/2015-3-23-screenshot1.png')]
  idPlugin: LegacyPowerUps.calendar
]

class PowerUpsExplainerView extends View
  events:
    "click .js-close-explainer": 'closeExplainer'
    "click .power-ups-explainer-learn-more": 'trackLearnMore'

  className: 'power-ups-explainer'

  render: ->

    html = t.render ->
      t.p '.power-ups-explainer-text', l('power-up explainer')
      t.a '.power-ups-explainer-learn-more', { href: '/power-ups', target: '_blank' }, ->
        t.format('learn-more')

      t.span '.power-ups-explainer-close.js-close-explainer', ->
        t.icon 'close'

    @$el.html html

    @

  closeExplainer: (e) ->
    @remove()
    Auth.me().dismiss("PowerUpsPaneExplainer")
    track('Board Menu', 'Dismiss Power-Ups Explainer')
    return

  trackLearnMore: ->
    track('Board Menu', 'Explainer Ad', 'Learn More Click')

spinnerTemplate = t.renderable ->
  t.div ->
    t.div '.spinner.loading'

class PowerUpsSpinnerView extends View
  render: ->
    @$el.html(spinnerTemplate())
    @

class PowerUpsUnlimitedExplanation extends View
  vigor: @VIGOR.NONE
  renderOnce: ->
    @$el.html t.render =>
      t.div '.count-explanation', =>
        t.p =>
          t.format 'board-has-been-added-to-the-team', {
            boardName: @model.get('name'),
            teamName: @model.getOrganization().get('displayName')
          }

        t.p =>
          t.format 'team-has-business-class-so-this-board-has-unlimited-access-to-power-ups', {
            teamName: @model.getOrganization().get('displayName')
          }

class PowerUpsLimitedExplanation extends View
  vigor: @VIGOR.NONE
  renderOnce: ->
    @$el.html t.render =>
      t.div '.count-explanation', =>
        t.p =>
          t.format 'board-has-been-added-to-the-team', {
            boardName: @model.get('name'),
            teamName: @model.getOrganization().get('displayName')
          }

        t.p =>
          t.format 'upgrade-to-business-class-for-unlimited-power-ups-and-moreupgrade-to-business-class'

class PowerUpsForTeamMembers extends View
  vigor: @VIGOR.NONE
  renderOnce: ->
    @$el.html t.render =>
      t.div '.count-explanation', =>
        t.p =>
          t.format 'only-team-members-can-enable-power-ups'

class PowerUpsLimitAd extends View
  className: 'power-ups-limit-reached'

  events:
    'click .js-upgrade-team': (e) ->
      track("Power-Ups Menu", "Banner Ad", "Get More Power-Ups Button")
    'click .power-ups-limit-reached-learn-more': ->
      track("Power-Ups Menu", "Banner Ad", "Learn More Link")
    'click .js-close-power-up-ad': 'closeAd'

  vigor: @VIGOR.NONE
  renderOnce: ->
    upgradeUrl = Controller.getBoardPowerUpsUpgradeUrl(@model)
    adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')
    me = Auth.me()

    html = t.render =>
      t.p '.power-ups-limit-reached-message', ->
        t.format 'it-looks-like-youve-reached-your-power-ups-limit-for-this-board'

      t.p '.power-ups-limit-reached-button', =>
        if @model.hasOrganization()
          t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
            t.format 'get-more-power-ups'
        else
          t.a '.button.primary.js-add-to-team', { href: '#' }, ->
            t.format 'get-more-power-ups'

      t.a '.power-ups-limit-reached-learn-more', { href: '/business-class', target: '_blank' }, ->
        t.format 'learn-more'

    experimentHtml = t.render =>
      t.span '.power-ups-ad-close.js-close-power-up-ad', ->
        t.icon 'close'
      t.div '.power-ups-ad-body', =>
        t.p '.power-ups-ad-title', ->
          t.format 'ads-title'
        t.p '.power-ups-ad-text', ->
          t.format 'ads-text'
        t.a '.power-ups-ad-learn-more', { href: '/business-class', target: '_blank' }, ->
          t.format 'ads-learn-more'

        t.p '.power-ups-limit-reached-button', =>
          if @model.hasOrganization()
            t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
              t.format 'ads-upgrade'
          else
            t.a '.button.primary.js-add-to-team', { href: '#' }, ->
              t.format 'ads-upgrade'

    if adsLayoutExperimentEnabled
      @$el
        .addClass 'ads-layout-experiment'
        .html experimentHtml
    else
      @$el.html html

  closeAd: (e) ->
    @remove()
    Auth.me().dismissAd("board-powerups-partial")
    return

class PowerUpsFullAd extends View
  className: 'power-ups-limit-reached-full'

  events:
    'click .js-no-thanks': (e) ->
      Auth.me().dismiss("PowerUpsLimitFullAd")
    'click .js-upgrade-team': (e) ->
      track("Power-Ups Menu", "Full-Menu Ad", "Get More Power-Ups Button")
    'click .js-add-to-team': (e) ->
      track("Power-Ups Menu", "Full-Menu Ad", "Get More Power-Ups Button")
    'click a[href="/business-class"]': ->
      track("Power-Ups Menu", "Full-Menu Ad", "Business Class Link")
    'click .power-ups-limit-reached-learn-more': ->
      track("Power-Ups Menu", "Banner Ad", "Learn More Link")
    'click .js-close-power-up-ad': (e) ->
      Auth.me().dismiss("PowerUpsLimitFullAd")

  vigor: @VIGOR.NONE
  renderOnce: ->
    upgradeUrl = Controller.getBoardPowerUpsUpgradeUrl(@model)
    adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')
    me = Auth.me()
    onOldBC = me.isInAnyBCOrganization()

    html = t.render =>
      t.div '.power-ups-limit-reached-full-content', =>
        t.p '.power-ups-limit-reached-message', ->
          t.format 'it-looks-like-youve-reached-your-power-ups-limit-for-this-board'

        t.p '.power-ups-limit-reached-sub', =>
          if me.isFeatureEnabled('threePlugins')
            # They have gold, so the only way to get more is to get BC
            t.format 'as-a-trello-gold-member-you-can-turn-on-three-power-ups-per-board'
            t.text ' '
            t.format 'business-class-teams-get-unlimited-power-ups'
          else if onOldBC
            # They're on an old version of BC, so we don't want to say that
            # they aren't paying at all
            t.format 'with-the-legacy-version-of-business-class-you-can-turn-on-one-power-up-per-board'
          else if @model.hasOrganization()
            # The board is in a team so we want to sell them on BC
            t.format 'business-class-teams-get-unlimited-power-ups'
          else
            # They aren't in a team, so we can sell them on BC or Gold
            t.format 'as-a-free-member-you-can-turn-on-one-power-up-per-board'
            t.text ' '
            t.format 'business-class-teams-get-unlimited-power-ups'

        t.p '.power-ups-limit-reached-sub', { style: 'margin: 8px 40px' }, =>
          if onOldBC
            t.format 'to-unlock-more-upgrade-your-team-to-the-latest-version-of-business-class-today'
          else
            t.format 'to-unlock-more-upgrade-to-business-class-today'

        t.p '.power-ups-limit-reached-button', =>
          if @model.hasOrganization()
            t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
              t.format 'lets-do-this'
          else
            t.a '.button.primary.js-add-to-team', { href: '#' }, ->
              t.format 'lets-do-this'

        t.div '.power-ups-limit-reached-no-thanks.js-no-thanks', ->
          t.format 'no-thanks'

    experimentHtml = t.render =>
      t.span '.power-ups-ad-close.js-close-power-up-ad', ->
        t.icon 'close'
      t.div '.power-ups-ad-body', =>
        t.p '.power-ups-ad-title', ->
          t.format 'ads-title'

        t.p '.power-ups-ad-text', =>
          if onOldBC
            t.format 'ads-text-oldBC'
          else
            t.format 'ads-text'

        t.a '.power-ups-ad-learn-more', { href: '/business-class', target: '_blank' }, ->
          t.format 'ads-learn-more'

        t.p '.power-ups-limit-reached-button', =>
          if @model.hasOrganization()
            t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
              t.format 'ads-upgrade'
          else
            t.a '.button.primary.js-add-to-team', { href: '#' }, ->
              t.format 'ads-upgrade'

    if adsLayoutExperimentEnabled
      @$el
        .addClass 'ads-layout-experiment'
        .html experimentHtml
    else
      @$el.html html


class PowerUpsRequest extends View
  events:
    "click .power-ups-request-let-us-know": (e) ->
      track('Board Menu', 'Request a Power-Up', 'Let Us Know Click')

  vigor: @VIGOR.NONE
  renderOnce: ->
    url = "https://trello.typeform.com/to/DLUonY?source=app&member=#{ Auth.myId() }"
    @$el.html t.render =>
      t.div '.power-ups-request', =>
        t.p '.quiet', =>
          t.format 'dont-see-what-youre-looking-for-let-us-know', { url: url }

class BoardPowerUpsListView extends View
  initialize: ->

  className: 'power-up-items'

  render: ->
    @appendSubview @subview(PowerUpsSpinnerView, @model)

    Promise.props
      powerups: _.map powerUpViewData, (powerUp) =>
        { name } = powerUp
        data = xtend powerUp,
          displayName: l(['power ups', name, 'name'])
          description: l(['power ups', name, 'description'])

        displayName: data.displayName
        view: @subview(BoardPowerUpItemView, @model, { powerUp: data }, name)

      plugins: Promise.try =>
        idPowerUpPlugins = _.pluck(powerUpViewData, 'idPlugin')

        ModelLoader.loadBoardAvailablePlugins(@model.id)
          .filter (plugin) =>
            plugin.id !in idPowerUpPlugins
          .map (plugin) =>
            displayName: PluginIOCache.get(plugin).getName()
            view: @subview(BoardPluginItemView, @model, { plugin }, plugin.id)
    .then ({ powerups, plugins }) =>
      sorted = _.chain([powerups, plugins])
      .flatten()
      .sortBy (item) -> item.displayName.toLowerCase()
      .pluck 'view'
      .value()

      if simpleTest('powerUpTaglines')?.get('showTaglines')
        @$el.addClass('power-up-item-taglines-experiment-enabled')

      @ensureSubviews sorted

      if simpleTest('powerUpRequestCTA')?.get('showCTA')
        @appendSubview @subview(PowerUpsRequest, @model)

    .done()

    @

class PowerUpsUpgradeView extends View
  className: 'power-ups-upgrade'

  initialize: ->

  events:
    'click .js-go-back': (e) ->
      track('Board Menu', 'Open Power-Ups', 'Dismiss Upsell')
      @model.trigger 'cancel-upgrade'

    'click .js-upgrade': (e) -> @model.trigger 'add-to-team'

  render: ->
    me = Auth.me()
    onOldBC = me.isInAnyBCOrganization()
    partOfTeam = @model.hasOrganization()
    upgradeUrl = Controller.getBoardPowerUpsUpgradeUrl(@model)
    hasGold = me.isFeatureEnabled('threePlugins')

    @$el.html(powerUpsUpgradeTemplate({ partOfTeam, upgradeUrl, hasGold, onOldBC }))
    @

module.exports = class BoardPowerUpsView extends View
  viewTitleKey: 'power ups'
  viewIcon: 'power-up'
  noPadding: true
  isTopLevelTab: true

  className: 'board-menu-content-frame power-ups-list'

  initialize: ->
    @listenTo @model, 'change:idOrganization change:powerUps', @frameDebounce @render
    @listenTo @model, 'added-to-team', =>
      @redirecting = true
      @render()
    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()
    @listenTo @model, 'cancel-upgrade', =>
      @initialViewState = null
      @render()
    @listenTo @model, 'add-to-team', =>
      @initialViewState = null
      @addToTeam = true
      @render()

    @listenTo @model.boardPluginList, 'add remove reset', @frameDebounce @render
    @listenTo Auth.me(), 'change:oneTimeMessagesDismissed', @frameDebounce @render
    @initialViewState = @options.viewState
    @explainLimits = false
    @redirecting = false
    @upgradeToBC = false
    # We only want to show the full page ad when they click a fake enable button
    @useFullAd = false

  events: ->
    'click .js-fake-enable': (e) ->
      Util.stop(e)
      @useFullAd = true
      @render()

    'click .js-add-to-team': (e) ->
      Util.stop(e)
      if !@model.owned()
        # We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class'
      else
        @addToTeam = true
        @render()

  render: ->
    org = @model.getOrganization()

    # removes explainer or ad that is on top
    @$el.empty()

    if @initialViewState == 'upsell'
      @renderUpgradeView()
      return @

    if @redirecting
      @renderSpinner()
    else if @addToTeam
      @renderAddToTeam()
    else
      @renderPowerUpsList()

    @

  renderSpinner: ->
    @appendSubview @subview(PowerUpsSpinnerView, @model)
    return @

  renderUpgradeView: ->
    @appendSubview @subview(PowerUpsUpgradeView, @model)

  renderAddToTeam: ->
    if @model.hasOrganization()
      # So the board is part of a team, we just can't see it
      # This is a weird situation; we're just not going to let them
      # mess with the power-ups in this case
      @appendSubview @subview(PowerUpsForTeamMembers, @model)
      return @

    # If something changes and this is added to a team, we want to explain
    # why the limits have changed
    @explainLimits = true

    ModelLoader.loadMyOrganizations()

    @appendSubview @subview(BoardAddToTeam, @model, {
      menuType: "Power-Ups"
    })

  renderPowerUpsList: ->
    upsellEnabled = !ClientConfig.get('dontUpsell')
    if !@model.canEnableAdditionalPowerUps() && upsellEnabled
      if Auth.me().isDismissed("PowerUpsLimitFullAd")
        if !Auth.me().isAdDismissed("board-powerups-partial")
          @appendSubview @subview(PowerUpsLimitAd, @model)
      else if @useFullAd
        @appendSubview @subview(PowerUpsFullAd, @model)
        return @
      else if !Auth.me().isDismissed("PowerUpsPaneExplainer")
        @appendSubview @subview(PowerUpsExplainerView, @model)
    else
      if upsellEnabled
        if !Auth.me().isDismissed("PowerUpsPaneExplainer")
          @appendSubview @subview(PowerUpsExplainerView, @model)

        if @explainLimits
          org = @model.getOrganization()
          if org?.isFeatureEnabled('plugins')
            @appendSubview @subview(PowerUpsUnlimitedExplanation, @model)
          else
            @appendSubview @subview(PowerUpsLimitedExplanation, @model)
    @appendSubview @subview(BoardPowerUpsListView, @model)



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-power-ups-view.coffee